import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=226a5853&scoped=true&"
var script = {}
import style0 from "./Footer.vue?vue&type=style&index=0&id=226a5853&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "226a5853",
  null
  
)

export default component.exports